import { gql } from "@apollo/client";

export const getOnboardingDataSchema = gql`
  query GetOnboardingData {
    getOnboardingData {
      data {
        id
        organizationId
        label
        path
        subSteps
      }
    }
  }
`;
export const getUserResponses = gql`
  query GetUserResponses {
    getUserResponses {
      id
      organizationId
      formResponses
      reviewed
    }
  }
`;
